import React, { useEffect, useState } from "react";
import { Select, Input as AntdInput } from "antd";

const fontWeights = Array.from({ length: 9 }, (_, i) => {
	const value = (i + 1) * 100;
	return { label: value.toString(), value: value.toString() };
});

const fontFamilies = [
	{ label: "Arial", value: "Arial, sans-serif" },
	{ label: "Verdana", value: "Verdana, sans-serif" },
	{ label: "Tahoma", value: "Tahoma, sans-serif" },
	{ label: "Trebuchet MS", value: "'Trebuchet MS', sans-serif" },
	{ label: "Times New Roman", value: "'Times New Roman', serif" },
	{ label: "Georgia", value: "Georgia, serif" },
	{ label: "Courier New", value: "'Courier New', monospace" },
	{ label: "Lucida Console", value: "'Lucida Console', monospace" },
	{ label: "Poppins", value: "'Poppins', sans-serif" },
	{ label: "Cairo", value: "'Cairo', sans-serif" },
];

export default function FormOptionsFonts({
	title,
	attribute,
	activeItem,
	updateActiveItem,
	id,
}) {
	const [value, setValue] = useState("");

	useEffect(() => {
		if (typeof activeItem === "string") {
			const match = activeItem.match(/^(\d+)(px)?$/);
			if (match && attribute === "fontSize") {
				setValue(match[1]);
			} else {
				setValue(activeItem);
			}
		}
	}, [activeItem, attribute]);

	useEffect(() => {
		if (value !== "") {
			let updatedValue = value;
			if (attribute === "fontSize") {
				updatedValue = `${value}px`;
			}
			updateActiveItem("css", (prev = {}) => ({
				...prev,
				[attribute]: updatedValue,
			}));
		}
	}, [value, attribute]);

	return (
		<div className="task-option-item">
			<label htmlFor={id} className="form-label">
				{title}
			</label>
			{attribute === "fontWeight" && (
				<div className="task-basic-style-options" style={{ display: "flex" }}>
					<Select
						style={{ width: "100%" }}
						options={fontWeights}
						value={value === "" ? "400" : value}
						onChange={(val) => setValue(val)}
						placeholder="Select font weight"
					/>
				</div>
			)}

			{attribute === "fontFamily" && (
				<div className="task-basic-style-options" style={{ display: "flex" }}>
					<Select
						style={{ width: "100%" }}
						options={fontFamilies}
						value={
							value === ""
								? localStorage.getItem("lang") === "ar"
									? "'Cairo', sans-serif"
									: "'Poppins', sans-serif"
								: value
						}
						onChange={(val) => setValue(val)}
						placeholder="Select font family"
						showSearch
						filterOption={(input, option) =>
							option?.label.toLowerCase().includes(input.toLowerCase())
						}
					/>
				</div>
			)}

			{attribute === "fontSize" && (
				<div className="task-basic-style-options" style={{ display: "flex" }}>
					<AntdInput
						type="number"
						value={value ? value : "14"}
						onChange={(e) => {
							setValue(e.target.value ? e.target.value : "14");
						}}
						min={1}
						placeholder="Font size in px"
					/>
				</div>
			)}
		</div>
	);
}
